import * as React from 'react';
import { CustomButton, ButtonType } from "soprasteria-ui-library";
import { useHistory } from 'react-router-dom';
import { GeneralDentalReferralActionButtons } from './GeneralDentalReferralActionButtons';

interface IGeneralDentalReferralFooterButtons {
    canEdit: boolean;
    canWithdraw: boolean;
    canReject: boolean;
    canRequestCompletion: boolean;
    canApprove: boolean;
    canWriteAnswer: boolean;
    hasUnreadAnswer: boolean;
    generalDentalReferralId?: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getGeneralDentalReferral: (id: number) => void;
}

export const GeneralDentalReferralFooterButtons: React.FunctionComponent<IGeneralDentalReferralFooterButtons> = ({ changeSuccessMessage, canEdit, canWithdraw, canReject, canRequestCompletion, canApprove, canWriteAnswer, hasUnreadAnswer, changeErrorMessage, getGeneralDentalReferral, generalDentalReferralId }) => {
    const history = useHistory();

    return (
        <>
            <div className="row">
                <div className="col-6 text-left">
                    <CustomButton buttonType={ButtonType.general} onClick={() => history.goBack()} buttonText="Gå tillbaka" />
                </div>
                <div className="col-6 text-right">
                    <GeneralDentalReferralActionButtons 
                        changeSuccessMessage={changeSuccessMessage}
                        changeErrorMessage={changeErrorMessage}
                        getGeneralDentalReferral={getGeneralDentalReferral}
                        canEdit={canEdit}
                        canWithdraw={canWithdraw}
                        canReject={canReject}
                        canApprove={canApprove}
                        canWriteAnswer={canWriteAnswer}
                        canRequestCompletion={canRequestCompletion}
                        hasUnreadAnswer={hasUnreadAnswer}
                        generalDentalReferralId={generalDentalReferralId} />
                </div>
            </div>
        </>
    )
}